__webpack_require__.p = "https://static.highsnobiety.com/interactive-stories/2024-03-nissan-kenlee/";